import Vue from 'vue'
import VueRouter from 'vue-router'
import clientMain from '@/modules/client/components/clientMain.vue'

Vue.use(VueRouter)
const routes = [
    {
        path: "/",
        name: "clientMain",
        component: clientMain
    }
]

export default new VueRouter({
    routes: routes

})
